import React, { useEffect, useState } from 'react';
import gsap from 'gsap';
import './Achievements.css';
import AchievementList from '../../components/AchievementList/AchievementList';
import RespAchievementList from '../../components/AchievementList/RespAchievementList';

const achievementsList = require('./achievementsList.json');

const Achievements = () => {
	const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const items = document.querySelectorAll(".achievementList li");

    items.forEach((el) => {
      gsap.set(".achImg", { xPercent: -50, yPercent: -50 });
      const image = el.querySelector(".achImg");
      const innerImage = el.querySelector(".achImg img");

      const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
      const mouse = { x: pos.x };
      const speed = 0.1;
      const xSet = gsap.quickSetter(image, "x", "px");

      let mouseMoveTimeout;

      window.addEventListener("mousemove", (e) => {
        mouse.x = e.x;

        // Detect end of mouse movement
        if (mouseMoveTimeout) clearTimeout(mouseMoveTimeout);
        mouseMoveTimeout = setTimeout(() => {
          innerImage.style.transform = "translateX(0%) rotate(0deg)";
        }, 150); // Adjust timeout duration as needed
      });

      gsap.ticker.add(() => {
        const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
        pos.x += (mouse.x - pos.x) * dt;
        xSet(pos.x);
      });

      let oldx = 0;
      let lastCursorX = 0;
      const cursorThreshold = 150;

      const mousemovemethod = (e) => {
        if (e.pageX < oldx && e.clientX <= lastCursorX - cursorThreshold) {
          innerImage.style.transform = "rotate(-15deg)";
          lastCursorX = e.clientX;
        } else if (e.pageX > oldx && e.clientX >= lastCursorX + cursorThreshold) {
          innerImage.style.transform = "rotate(15deg)";
          lastCursorX = e.clientX;
        }
        oldx = e.pageX;
      };

      document.addEventListener("mousemove", mousemovemethod);
    });
  }, []);

  return (
    <div className="achievementContainer" id="ach">
      <div className='text-2xl mb-10 font-bai'>
        <span className='text-neon font-extrabold' data-aos="zoom-in-left" data-aos-offset="120">&lt;</span>
        <span data-aos="zoom-in-up" data-aos-offset="120"> Achievements </span>
        <span className='text-neon font-extrabold' data-aos="zoom-in-right" data-aos-offset="120">/ &gt;</span>
      </div>
      <ul className="achievementList">
        {achievementsList.map((achievement, i) => (
          <AchievementList key={i} achievement={achievement} />
        ))}
      </ul>
      <ul className="respAchList w-full mx-auto">
        {achievementsList.map((achievement, i) => (
          <RespAchievementList key={i} achievement={achievement} 
					isOpen={openIndex === i}
					toggleOpen={() => setOpenIndex(openIndex === i ? null : i)}/>
        ))}
      </ul>
    </div>
  );
};

export default Achievements;
